module.exports = __webpack_public_path__ + "img/giftsshop.b2ff14cf.svg";